import { render, staticRenderFns } from "./BatchRecieveModalConfirm.vue?vue&type=template&id=4607e876"
import script from "./BatchRecieveModalConfirm.vue?vue&type=script&lang=js"
export * from "./BatchRecieveModalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports